export default __webpack_public_path__ + "static/media/GrapeNovel.1eefcf79.png";